import {CSSProperties} from "react";
import classNames from "classnames";

type HeaderProps = {
    titleText: string;
    boldTitleText?: string;
}

const Header = ({titleText, boldTitleText} : HeaderProps) : JSX.Element => {
    return (
        <p className={"custom-tooltip-title-question"}>
            <span className={"custom-tooltip-title-number"}>
                {boldTitleText ?? ""}
            </span>
            {titleText}
        </p>
    );
}

type ItemProps = {
    index: number;
    color: string;
    text:string;
    subtleText?:string;
}

const Item = ({index, color, text, subtleText}: ItemProps): JSX.Element => {
    return (
        <>
            <p key={index} className={"custom-tooltip-dataset"}
               style={{"--dataset-color": color} as CSSProperties}>
                {text}
            </p>
            {subtleText &&
                <p className={"subtle"}>
                    {subtleText}
                </p>
            }
        </>
    );
}

type CustomTooltipContentDefaultProps = {
    backgroundOverride?:string;
    additionalClasses?: string;
}

type CustomTooltipContentProps = React.PropsWithChildren<CustomTooltipContentDefaultProps>;

const CustomTooltipContent = (props: CustomTooltipContentProps) => {
    return (
        <div className={classNames("custom-tooltip", props.additionalClasses)} style={{backgroundColor: props.backgroundOverride}}>
            {props.children}
        </div>
    );
}

export default Object.assign(
    CustomTooltipContent,
    {
        Header,
        Item
    },
);
